/**
 * COURE.QUIZ.SERVICE.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Status } from './status';

export interface Campaign { 
    id?: string;
    shortcode?: string;
    ownerId?: string;
    keyword?: string;
    campaignName?: string;
    campaignDescription?: string;
    serviceId?: string;
    status?: Status;
    startDate?: Date;
    endDate?: Date;
    dateCreated?: Date;
}